import { type QueryClient } from '@tanstack/react-query';
import { type RouteObject } from 'react-router-dom';

import { requirePermissions } from '@/app/requirePermissions';
import { PagePermissions } from '@/models/pagePermissions';

export const giftRoute = (queryClient: QueryClient): RouteObject => ({
  path: 'gifts',
  // On the parent, so the child keeps its own data loader untouched.
  loader: requirePermissions({ oneOf: PagePermissions.gifts }),
  children: [
    {
      index: true,
      lazy: async () => {
        const { loader, Component } = await import('./gifts');
        return { loader: loader(queryClient), Component };
      },
    },
  ],
});
